import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthSessionService } from '../../service/auth-session.service';
import { StorageService } from '../../service/storage.service';

// File name retained exactly as supplied (including "gurad") to allow replacement.
export const authGuard: CanActivateFn = (_route, state) => {
  const storage = inject(StorageService);
  const session = inject(AuthSessionService);
  const router = inject(Router);

  if (storage.isAuthenticated() && storage.getToken()) {
    return true;
  }

  // A guard returns a UrlTree; it must not start a second navigation itself.
  session.clearSession();
  return router.createUrlTree(['/signin'], {
    queryParams: { returnUrl: state.url },
  });
};
